import React, { useState } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../api/app/appInfoApi';
import { ConnectedServices } from '../../types/app/appInfo.types';
import { Loader } from '../../components/core/Loader/Loader';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Link } from '@mui/material';
import { useTranslation } from '../../contexts/translation';

export function MasterDataRedirect() {
  let link = '';
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { data, isLoading, isError } = useQuery<ConnectedServices>(
    ['connectedServices'],
    () => api.getConnectedServices(),
    { enabled: link === '', refetchInterval: false },
  );
  if (data) link = data.MasterDataDao;
  const openOnce = () => {
    if (!open) {
      link !== '' && window.open(link, 'toolbar=no,resizable=yes,location=yes');
      setOpen(true);
    }
  };

  const handleOnClick = () => {
    link !== '' && window.open(link, 'toolbar=no,resizable=yes,location=yes');
  };

  if (isError) return <ApiError />;
  if (isLoading || !data) return <Loader />;
  return (
    <>
      {openOnce()}
      <Link onClick={handleOnClick} variant="h5">
        {t('page.master-data-redirect.main-message')}
      </Link>
    </>
  );
}
